import { render, staticRenderFns } from "./mark-as-issuing.vue?vue&type=template&id=a499c064&scoped=true&"
import script from "./mark-as-issuing.vue?vue&type=script&lang=js&"
export * from "./mark-as-issuing.vue?vue&type=script&lang=js&"
import style0 from "./mark-as-issuing.vue?vue&type=style&index=0&id=a499c064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a499c064",
  null
  
)

export default component.exports